module.exports = __webpack_public_path__ + "img/mood_shock.6e0aa5b6.png";